import React from 'react';
import { Phone } from 'lucide-react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-slate-200 shadow-sm" data-id="element-184" data-mp="2dmeaobaroi9g">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185" data-mp="2ilh2uv5neu00">
        <div className="flex justify-between items-center h-20" data-id="element-186" data-mp="2ijwbfeemrr6d">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-187" data-mp="2nlbu4ztc5lll">
            <a href="#" aria-label="Palm Beach Powerstroke home" className="flex items-center" data-id="element-188" data-mp="2rmfcpu2rpvqi">
              <img src="https://cdn.magicpatterns.com/uploads/3E6yWLuy4Bv7oaw2PFgCLC/logo_trent_.jpg" alt="Palm Beach Powerstroke" className="h-14 w-auto" data-id="element-189" data-mp="2wjfh80jyyqfi" />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-190" data-mp="3bbppaz77w0ke">
            <a href="#expertise" className="text-slate-600 hover:text-orange font-medium transition-colors" data-id="element-191" data-mp="3fbgmbknc7cxd">
              Our Expertise
            </a>
            <a href="#services" className="text-slate-600 hover:text-orange font-medium transition-colors" data-id="element-192" data-mp="2rm19b2nk3u6n">
              Specialized Services
            </a>
            <a href="#about" className="text-slate-600 hover:text-orange font-medium transition-colors" data-id="element-193" data-mp="2hntuapctvm7a">
              Why Us
            </a>
            <a href="#appointment" className="text-dark hover:text-orange font-bold transition-colors" data-id="element-194" data-mp="3fd6n7c9xsceb">
              Book Appointment
            </a>
            <a href="#contact" className="text-slate-600 hover:text-orange font-medium transition-colors" data-id="element-195" data-mp="35jg64sg5348n">
              Contact
            </a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center ml-8 lg:ml-12" data-id="element-196" data-mp="3tali2wiylcdo">
            <a href="tel:9548710290" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-bold rounded-md text-white bg-orange hover:bg-orange/90 transition-all shadow-lg shadow-orange/30 hover:shadow-orange/50 hover:-translate-y-0.5" data-id="element-197" data-mp="3t9afh0192ao5">
              <Phone className="w-5 h-5 mr-2" data-id="element-198" data-mp="1mmbehhlfmgo5" />
              CALL: 954-871-0290
            </a>
          </div>

          {/* Mobile menu button (visual only for this demo) */}
          <div className="flex items-center md:hidden" data-id="element-199" data-mp="18pg0rbu8k11r">
            <button type="button" className="text-slate-500 hover:text-dark focus:outline-none" aria-label="Open menu" data-id="element-200" data-mp="1cpggczt2miae">
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-201" data-mp="13n78khp6t30p">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" data-id="element-202" data-mp="2y204yixw9xtp" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>;
}